Array of identifiers for the `HiringOrganization` that will post or update the job ad.

The `seekAnz` scheme requires exactly one element.
